/**
 * d1-search-suggest — Suchvorschlaege, "Haeufig gesucht" und "Zuletzt gesucht".
 *
 * Warum eigener Index: Shopifys native Begriffsvorschlaege
 * (predictive_search.resources.queries) feuern nur fuer eine Handvoll gelernter
 * Begriffe (Stand 2026-09: 5 Stueck fuer diesen Shop). Der Index in
 * assets/d1-search-terms.json wird naechtlich aus echten Suchanfragen
 * (ShopifyQL search_queries) plus Katalogbegriffen gebaut.
 *
 * Aktiviert von assets/predictive-search.js ueber die d1-search-suggest-Hooks.
 * Komplett entfernbar: Hooks raus, diese Datei + CSS + JSON loeschen.
 */
(function () {
  if (window.D1SearchSuggest) return;

  var MAX_SUGGESTIONS = 6;
  var MAX_CROSS = 6;
  // Welcher Reiter wird in der Vorschlagsspalte gegengespiegelt
  var CROSS = { products: 'collections', collections: 'products',
                articles: 'products', pages: 'products', articles_and_pages: 'products' };
  var TYPES = ['articles_and_pages', 'collections', 'products', 'articles', 'pages'];
  var MAX_RECENT = 6;
  var RECENT_KEY = 'd1_recent_searches';
  // Saison-Chips (2026-10-05): A/B-Test beendet, alle sehen sie; alte Testgruppe aufraeumen
  try { localStorage.removeItem('d1_chip_ab'); } catch (e) { /* privater Modus */ }
  var UMLAUT = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss', 'é': 'e', 'è': 'e', 'ê': 'e', 'á': 'a', 'à': 'a', 'í': 'i', 'ó': 'o', 'ú': 'u', 'ñ': 'n' };

  var index = null;
  var loading = null;

  function norm(s) {
    s = String(s || '').toLowerCase();
    s = s.replace(/[äöüßéèêáàíóúñ]/g, function (c) { return UMLAUT[c] || c; });
    s = s.normalize ? s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '') : s;
    return s.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function searchUrl(term) {
    // Aus dem Formular lesen statt hart '/search': die Markets-Domains laufen
    // unter /fr/search, /en/search usw.
    var form = document.querySelector('predictive-search form.search') || document.querySelector('form.search');
    var root = (form && form.getAttribute('action')) || '/search';
    return root + '?q=' + encodeURIComponent(term);
  }

  /** Laedt den Begriffsindex einmalig. Faellt bei Fehler still auf "kein Index" zurueck. */
  function load(url) {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    loading = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        index = data;
        index._n = (data.terms || []).map(function (t) { return norm(t[0]); });
        // Schreibvarianten (Tippfehler, fehlende Leerzeichen) aus dem Index v2, drittes Element
        index._a = (data.terms || []).map(function (t) { return t[2] ? String(t[2]).split('|') : []; });
        return index;
      })
      .catch(function () { index = { terms: [], popular: [], _n: [] }; return index; });
    return loading;
  }

  /**
   * Damerau-Levenshtein, abgebrochen sobald > 1 - also eine Einfuegung,
   * Loeschung, Ersetzung ODER ein Buchstabendreher. Der Dreher ist der
   * haeufigste Tippfehler ("felgenreingier" statt "felgenreiniger") und
   * waere in reinem Levenshtein Distanz 2, also unerreichbar.
   */
  function within1(a, b) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (la === lb && a[i + 1] === b[j] && a[i] === b[j + 1]) { i += 2; j += 2; continue; } // Dreher
      if (la > lb) i++;
      else if (lb > la) j++;
      else { i++; j++; }
    }
    return edits + (la - i) + (lb - j) <= 1;
  }

  /**
   * Rangfolge: exakt > Praefix > Wortanfang > enthalten > Tippfehler.
   * Der Index-Score (1..999) entscheidet innerhalb einer Stufe.
   */
  /** Trefferstufe eines normalisierten Begriffs fuer die Eingabe q (0 = kein Treffer). */
  function tierOf(n, q) {
    if (n === q) return 5;
    if (n.indexOf(q) === 0) return 4;
    if (n.indexOf(' ' + q) > -1) return 3;
    if (n.indexOf(q) > -1) return 2;
    return 0;
  }

  function match(query, limit) {
    if (!index || !index.terms.length) return [];
    var q = norm(query);
    if (q.length < 2) return [];
    var out = [];
    for (var i = 0; i < index.terms.length; i++) {
      var n = index._n[i], w = index.terms[i][1], tier = tierOf(n, q);
      var al = index._a ? index._a[i] : [];
      for (var j = 0; j < al.length && !tier; j++) tier = tierOf(al[j], q);
      if (tier) out.push({ t: index.terms[i][0], s: tier * 1000 + w });
    }
    if (out.length < 3 && q.length >= 4) {
      for (var k = 0; k < index.terms.length; k++) {
        var hit = within1(index._n[k], q), ak = index._a ? index._a[k] : [];
        for (var m = 0; m < ak.length && !hit; m++) hit = within1(ak[m], q);
        if (hit) out.push({ t: index.terms[k][0], s: 1000 + index.terms[k][1] });
      }
    }
    var seen = {};
    return out.sort(function (a, b) { return b.s - a.s; })
      .filter(function (o) { var n2 = norm(o.t); if (seen[n2]) return false; seen[n2] = 1; return true; })
      .slice(0, limit || MAX_SUGGESTIONS)
      .map(function (o) { return o.t; });
  }

  // ── Zuletzt gesucht (nur localStorage, verlaesst den Browser nie) ──
  var recent = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
    },
    add: function (term) {
      term = String(term || '').trim();
      if (term.length < 2) return;
      try {
        var list = recent.get().filter(function (t) { return norm(t) !== norm(term); });
        list.unshift(term);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
      } catch (e) { /* privater Modus / Speicher voll: still ignorieren */ }
    },
    clear: function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} }
  };

  function track(name, params) {
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) { /* Tracking ist ein Extra */ }
  }

  var chipsViewSent = false;

  /** "Haeufig gesucht" als Chip-Liste: die letzten Plaetze zeigen index.season.chips. */
  function popularChips(pop) {
    var season = (index && index.season && index.season.chips) || [];
    var sid = (index && index.season && index.season.id) || '';
    var g = 'alle';
    var items = pop.map(function (t) { return { t: t, k: 'p' }; });
    if (season.length) {
      var keep = items.slice(0, Math.max(0, items.length - season.length));
      var seen = {};
      keep.forEach(function (o) { seen[norm(o.t)] = 1; });
      items = keep.concat(season.filter(function (t) { return !seen[norm(t)]; })
        .map(function (t) { return { t: t, k: 's' }; }));
    }
    if (!chipsViewSent && items.length) {
      chipsViewSent = true;
      track('d1_chips_view', { d1_group: g, d1_season: sid });
    }
    return items.map(function (o, i) {
      return '<a class="d1-chip" href="' + esc(searchUrl(o.t)) + '" data-d1-term="' + esc(o.t)
        + '" data-d1-chip="' + g + '|' + o.k + '|' + (i + 1) + '">' + esc(o.t) + '</a>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-d1-chip]') : null;
    if (!el) return;
    var p = String(el.getAttribute('data-d1-chip')).split('|');
    track('d1_chip_click', { d1_group: p[0], d1_kind: p[1], d1_slot: Number(p[2]) || 0,
      d1_term: el.getAttribute('data-d1-term') || '',
      d1_season: (index && index.season && index.season.id) || '', transport_type: 'beacon' });
  }, true);

  function chips(items) {
    return items.map(function (t) {
      return '<a class="d1-chip" href="' + esc(searchUrl(t)) + '" data-d1-term="' + esc(t) + '">' + esc(t) + '</a>';
    }).join('');
  }

  /** Markup fuer das leere Suchfeld: zuletzt gesucht + haeufig gesucht. */
  function idleMarkup(labels) {
    var r = recent.get();
    var pop = (index && index.popular) || [];
    if (!r.length && !pop.length) return '';
    var html = '<div class="predictive-search absolute bg-theme-bg text-theme-text text-start">'
      + '<div class="predictive-search__scroller overflow-auto"><div class="d1-search-idle">';
    if (r.length) {
      html += '<div class="d1-search-idle__block"><h3 class="d1-search-idle__title h6">' + esc(labels.recent)
        + '<button type="button" class="d1-chip-clear link" data-d1-clear-recent>' + esc(labels.clear) + '</button></h3>'
        + '<div class="d1-chips">' + chips(r) + '</div></div>';
    }
    if (pop.length) {
      html += '<div class="d1-search-idle__block"><h3 class="d1-search-idle__title h6">' + esc(labels.popular) + '</h3>'
        + '<div class="d1-chips">' + popularChips(pop) + '</div></div>';
    }
    return html + '</div></div></div>';
  }

  /** Ressourcentyp eines Panels aus seiner ID ableiten (id = "<inputId>-<typ>"). */
  function typeOf(el) {
    if (!el || !el.id) return null;
    for (var i = 0; i < TYPES.length; i++) {
      if (el.id.slice(-(TYPES[i].length + 1)) === '-' + TYPES[i]) return TYPES[i];
    }
    return null;
  }

  /** Beschriftung aus dem zugehoerigen Reiter lesen - dann stimmt die Sprache immer. */
  function tabLabel(root, type) {
    var btn = root.querySelector('[role="tab"][aria-controls$="-' + type + '"]');
    return btn ? btn.textContent.trim() : '';
  }

  /** Eintraege eines (auch versteckten) Panels als Titel + URL einsammeln. */
  function panelItems(root, type, limit) {
    var panel = root.querySelector('[role="tabpanel"][id$="-' + type + '"]');
    if (!panel) return [];
    var out = [];
    var links = panel.querySelectorAll('.predictive-search__item:not(.js-submit) a.js-search-link');
    for (var i = 0; i < links.length && out.length < limit; i++) {
      var title = links[i].querySelector('.predictive-result__title');
      var text = (title ? title.textContent : links[i].textContent).trim();
      if (text) out.push({ t: text, u: links[i].getAttribute('href') });
    }
    return out;
  }

  /**
   * Spiegelt in der Vorschlagsspalte den jeweils anderen Reiter:
   * Produkte aktiv -> Kategorien, Kategorien aktiv -> Produkte,
   * Beitraege/Seiten aktiv -> Produkte. Die Daten stehen schon im DOM,
   * die Section rendert alle Panels und blendet nur aus.
   */
  function renderCross(root) {
    var col = root.querySelector('.predictive-search__suggestions');
    if (!col) return false;
    var old = col.querySelector('.d1-cross');
    if (old) old.parentNode.removeChild(old);

    var items = crossItems(root);
    if (!items.length) {
      col.classList.remove('d1-has-cross');
      return false;
    }

    var div = document.createElement('div');
    div.className = 'd1-cross';
    div.innerHTML = '<h3 class="predictive-result__title h6 tablist__scroller font-body regular-text font-bold">'
      + esc(items.label) + '</h3>'
      + '<ul class="predictive-search__list" role="list">'
      + items.map(function (o) {
          return '<li class="predictive-search__item" role="option">'
            + '<a class="predictive-result predictive-result--suggestion block focus-inset js-search-link" href="'
            + esc(o.u) + '">' + esc(o.t) + '</a></li>';
        }).join('')
      + '</ul>';
    var inner = ensureSticky(col);
    // Vor dem "Alle Suchergebnisse"-Link einsortieren, der bleibt immer unten
    inner.insertBefore(div, inner.querySelector('.d1-cross-all'));
    return true;
  }

  /**
   * Klebender Wrapper in der Vorschlagsspalte. Die Spalte selbst darf NICHT
   * kleben: sie traegt Hintergrund und Trennlinie und muss dafuer auf voller
   * Hoehe bleiben - sonst endet der graue Kasten mitten im Dropdown.
   */
  function ensureSticky(col) {
    var inner = col.querySelector('.d1-sticky');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'd1-sticky';
      while (col.firstChild) inner.appendChild(col.firstChild);
      col.appendChild(inner);
    }
    col.classList.add('d1-has-cross');
    return inner;
  }

  /**
   * "Alle Suchergebnisse anzeigen" unten in der Vorschlagsspalte. Fuehrt mit
   * d1_all=1 an der Direkttreffer-Weiterleitung vorbei: wer "sonax" tippt und
   * hier klickt, will die Liste sehen, nicht die Markenseite. Text und Icon
   * kommen aus dem gleichnamigen Button im Panel - damit stimmt die Sprache.
   */
  function renderViewAll(root, query) {
    var col = root.querySelector('.predictive-search__suggestions');
    var btn = root.querySelector('.predictive-search__view-all');
    if (!col || !btn || !query) return;
    var inner = ensureSticky(col);
    var old = inner.querySelector('.d1-cross-all');
    if (old) old.parentNode.removeChild(old);
    var a = document.createElement('a');
    a.className = 'd1-cross-all predictive-result predictive-result--suggestion block focus-inset link has-ltr-icon';
    a.href = searchUrl(query) + '&d1_all=1';
    a.setAttribute('data-d1-term', query);
    a.innerHTML = btn.innerHTML;
    inner.appendChild(a);
  }

  /** Eintraege des Gegen-Reiters plus dessen Beschriftung. */
  function crossItems(root) {
    var active = root.querySelector('[role="tabpanel"]:not([hidden])');
    var other = CROSS[typeOf(active)];
    var list = other ? panelItems(root, other, MAX_CROSS) : [];
    list.label = other ? tabLabel(root, other) : '';
    return list;
  }

  /** Reiterwechsel beobachten - faengt Klick und Tastatur gleichermassen. */
  function watchTabs(root) {
    var list = root.querySelector('[role="tablist"]');
    if (!list || list.d1Watched) return;
    list.d1Watched = true;
    new MutationObserver(function () { renderCross(root); })
      .observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
  }

  /**
   * Vorschlaege einhaengen - an zwei verschiedenen Stellen, je nach Zustand:
   *
   * Mit Treffern: in die native "Vorschlaege"-Spalte rechts, wie Shopify es tut,
   *   darunter der gegengespiegelte Reiter.
   * Ohne Treffer: als Chips oben im Null-Treffer-Block. Die Seitenspalte ist
   *   300px breit und wuerde dem Rest nur ~530px lassen, in denen sich die
   *   Produktkarten quetschen. Oben als Chips liest es sich ausserdem besser
   *   ("Keine Ergebnisse ... - Vorschlaege: brush, wheel brush").
   */
  function injectSuggestions(root, query, label) {
    if (!root || !index) return;
    var results = root.querySelector('.predictive-search__results');
    var scroller = root.querySelector('.predictive-search__scroller');
    if (!results || !scroller) return;

    var terms = match(query, MAX_SUGGESTIONS).filter(function (t) { return norm(t) !== norm(query); });

    var noResults = results.querySelector('.d1-no-results');
    if (noResults) {
      if (!terms.length || noResults.querySelector('.d1-no-results__suggest')) return;
      var inline = document.createElement('div');
      inline.className = 'd1-no-results__suggest';
      inline.innerHTML = '<h3 class="d1-no-results__title h6">' + esc(label) + '</h3>'
        + '<div class="d1-chips">' + chips(terms) + '</div>';
      // hinter die Meldung, vor die Kategorien
      noResults.insertBefore(inline, noResults.children[1] || null);
      return;
    }

    var col = results.querySelector('.predictive-search__suggestions');
    if (!col) {
      // Spalte auch dann anlegen, wenn es nur den Gegen-Reiter zu zeigen gibt
      if (!terms.length && !crossItems(results).length) return;
      col = document.createElement('div');
      col.className = 'predictive-search__suggestions relative pt-2 md:pt-0';
      if (terms.length) {
        col.innerHTML = '<ul class="predictive-search__list predictive-result__list-suggestions" role="list">'
          + '<h3 class="predictive-result__title h6 tablist__scroller font-body regular-text font-bold mt-3">'
          + esc(label) + '</h3>'
          + terms.map(function (t) {
              return '<li class="predictive-search__item" role="option">'
                + '<a class="predictive-result predictive-result--suggestion block focus-inset js-search-link" href="'
                + esc(searchUrl(t)) + '" data-d1-term="' + esc(t) + '">' + esc(t) + '</a></li>';
            }).join('')
          + '</ul>';
      }
      results.insertBefore(col, results.firstChild);
      scroller.classList.add('predictive-search__scroller--suggestions');
    }
    renderCross(results);
    renderViewAll(results, query);
    watchTabs(results);
  }

  /**
   * Ergebnisseite: Kategorien nachholen. Sie fehlen dort systembedingt
   * (Shopifys /search kennt nur product, page, article), obwohl das Dropdown
   * sie zeigt. Ein leichter JSON-Aufruf gleicht das aus.
   */
  function initSearchPage() {
    var el = document.querySelector('.d1-search-collections[data-search-terms]');
    if (!el || el.d1Done) return;
    el.d1Done = true;
    var q = el.getAttribute('data-search-terms');
    if (!q) return;
    // Section-Render statt JSON: die JSON-Antwort liefert bei den meisten
    // Markenwelt-Collections featured_image = null. In Liquid faellt
    // collection-card dagegen auf das erste Produktbild zurueck, deshalb holen
    // wir fertiges Markup statt roher Daten.
    var base = (window.theme && theme.routes && theme.routes.predictiveSearch) || '/search/suggest';
    fetch(base + '?q=' + encodeURIComponent(q)
          + '&resources[type]=collection&resources[limit]=10'
          + '&section_id=d1-search-collections', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var tmpl = document.createElement('template');
        tmpl.innerHTML = html;
        var sec = tmpl.content.querySelector('#shopify-section-d1-search-collections');
        if (!sec || !sec.innerHTML.trim()) return;
        // Exakter Collection-Titel -> direkt auf die Collection. Serverseitig laeuft
        // derselbe Abgleich ueber den Handle; hier faengt er die Faelle, in denen der
        // Handle nicht aus dem Titel ableitbar ist ("Waschen & Reinigen" ->
        // waschen-und-reinigen). Nicht springen, wenn der Kunde verfeinert oder
        // ausdruecklich alle Ergebnisse sehen will.
        var d1SprungAktiv = false; // 2026-09-06 (Jasper): Direktsprung aus, auf true setzen zum Wiedereinschalten
        if (d1SprungAktiv && !/[?&](filter\.|sort_by=|page=|d1_all=)/.test(window.location.search)) {
          var nq = norm(q);
          var items = tmpl.content.querySelectorAll('[data-d1-title]');
          for (var i = 0; i < items.length; i++) {
            if (norm(items[i].getAttribute('data-d1-title')) === nq && items[i].getAttribute('data-d1-url')) {
              window.location.replace(items[i].getAttribute('data-d1-url'));
              return;
            }
          }
        }
        el.innerHTML = sec.innerHTML;
        el.hidden = false;
        if (window.initLazyImages) window.initLazyImages();
      })
      .catch(function () { /* Kategorien sind ein Extra - stillschweigend weglassen */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }

  window.D1SearchSuggest = {
    load: load, match: match, recent: recent,
    idleMarkup: idleMarkup, injectSuggestions: injectSuggestions, norm: norm,
    initSearchPage: initSearchPage
  };
})();
